import AppLayout from '@/components/app/AppLayout.vue'
import { createApp } from 'vue'

const app = createApp(AppLayout)
app.mount('#app-root')
